/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo } from "react";
import { getShopUrl, getExportConfig, getTrialStatus, ChargeUrl } from '../Services/CommonServices';
import { downloadMetaobjectBulkResult, metaobjectBulkCancel, MetaobjectBulkPolling, DeleteMetaobjectLogs,metaobjectExportStatus, getMetaobjectImportHistory, MetaobjectDefinitions, MetaobjectFields } from '../Services/MetaobjectService';
import { environment } from '../Services/environment';
import { validConversionPrice } from '../Validation/regex';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { errorMetaModal, errorModal } from '../common/ErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import ExportStatusCard from '../common/ExportStatusCard';
import MappingModal from '../common/MappingModal';
import { useNavigate } from 'react-router-dom';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import WatermarkImage from '../../assets/3129492.jpg';

// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function ShopifyMetaobject({ blockUpload,eventSource }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [mappedHeaders, setMappedHeaders] = useState({});
    const CHUNK_SIZE = 1048576; // 1MB
    const [file, setFile] = useState();
    const [dropZoneKey, setDropZoneKey] = useState(0);
    const [logsLoading, setLogsLoading] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState();
    const hasError = rejectedFiles != null;
    const validFileTypes = ['.csv','.CSV','text/csv','.xlsx','.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setUploadBtnLoading(false);
            setUploadStatus(false);
            setBulkStatus("");
            setFile(acceptedFiles[0]);
            setRejectedFiles(_rejectedFiles[0]);
        },
        [],
    );
    const [metaobjectDefinitions, setMetaobjectDefinitions] = useState([]);
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [mutationType, setMutationType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [exportStatus, setExportStatus] = useState("");
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [conversionPrice, setConversionPrice] = useState();
    const [configLoading, setConfigLoading] = useState(false);
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [logs, setLogs] = useState([]);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [loadingMap, setLoadingMap] = useState({});

    const pageSize = 10;
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
    const handleChangeConversionPrice = useCallback((newValue) => { if (ValidatePrice(newValue)) { setConversionPrice(newValue) } }, []);
    
    // Memoized UI Components
    const fileUpload = useMemo(() => 
        !file && <s-text>Click here to upload a file</s-text>
    , [file]);
    
    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" align="center">
                <s-thumbnail
                    size="small"
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : ''
                    }
                />
                <div>
                    <s-text as="span">
                        {file.name}
                    </s-text>
                    <s-text as="p">
                        {file.size} bytes
                    </s-text>
                </div>
            </s-stack>
        )
    , [file, validFileTypes]);

    const [vendorArray, setVendorArray] = useState([]);
    const [popoverActive, setPopoverActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const [bulkErrorActive, setBulkErrorActive] = useState(false);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [metaobjectDeleteStatus, setMetaobjectDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitMetaobjects, setSplitMetaobjects] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [metaobjectBulkCancelStatus, setBulkCancelStatus] = useState("")
    const [emailMarketingUpdate,setEmailMarketingUpdate] = useState(undefined);
    const [selectedExportFilters, setSelectedExportFilters] = useState([]);
    const [active, setActive] = useState(false);
    const handleChangeModal = useCallback(() => { if (!active) { QueryMetaobjectDefinitions(); }  setActive(!active); }, [active]);
    const [selectedType, setSelectedType] = useState("");
    const [totalMetaobjectCount, setTotalMetaobjectCount] = useState(null);
    const [exportFilterMsg, setExportFilterMsg] = useState(null);

    // Trial Authorization States
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);

    const [isModalActive, setIsModalActive] = useState(false);
    const [ mapModalLodaing, setMapModalLoading] = useState(false);
    const [exportModalLoading,setExportModalLoading] = useState(false);
  // Example headers
  const [shopifyHeaders,setShopifyHeaders] = useState([]);
  const [catalogHeaders,setCatalogHeaders] = useState([]);
  const [formSubmit, setFormSubmit] = useState(false);
    useEffect(() => {
        getConfigExport();
        setFile(null);
        deleteOlderLogs();
        statusPolling();
        getLogs();
        checkExportStatus();
        loadTrialStatus(); // Load trial authorization
    }, []);

    // Refetch export config when export completes
    useEffect(() => {
        if (exportStatus === "completed" || exportStatus === "failed") {
            // Small delay to ensure backend has updated the config
            const timer = setTimeout(() => {
                getConfigExport();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [exportStatus]);

    useEffect(() => {
        // Re-mount drop zone when selected file is cleared so selecting the same file name fires input again.
        if (!file) {
            setDropZoneKey((prev) => prev + 1);
        }
    }, [file]);

    useEffect(() => {
        const normalizedStatus = (bulkStatus || "").toString().toLowerCase();
        if (["completed", "failed", "canceled", "cancelled", "expired"].includes(normalizedStatus)) {
            setUploadStatus(false);
            setUploadBtnLoading(false);
        }
    }, [bulkStatus]);

    // ========== Trial Authorization Functions ==========
    
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            // Show banner if trial expired and no active charge
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true; // Loading state, allow temporarily
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };
    
    // ========== End Trial Authorization Functions ==========

    useEffect(() => {
        if(!blockUpload)
        {
        GetMetaObjectFields();
        }
    }, [selectedType]);


    useEffect(() => {
        if(formSubmit)
        {
            handleSubmit();
        }
    }, [mappedHeaders,formSubmit]);


    const handleSubmit = () => {
        const isTitleMapped = Object.keys(mappedHeaders).some((key) => key === "Handle");
        if (isTitleMapped) {
            const jsonData = JSON.stringify(mappedHeaders);
            const formData = new FormData();
            formData.append('MappingData', jsonData);
            formData.append('File', file, file.name);
            formData.append('StoreUrl', storeUrl);
            formData.append('Type', selectedType);
            const requestOptions = {
              method: 'POST',
              body: formData,
            };
    
            setUploadBtnLoading(true);
            fetch(endpoint + '/api/Metaobject/process-mappings', requestOptions)
              .then((response) => {
                if (response.status === 400) {
                  return response.json().then((errorData) => {
                    if (errorData.message.includes('metafields')) {
                      throw new Error(`Metaobject mapping: ${errorData.message}`);
                    }
                    else {
                      throw new Error(`Bad Request: ${errorData.message}`);
                    }
                  });
                } else if (response.status === 500) {
                  return response.text().then((errorText) => {
                    throw new Error(errorText || 'Internal Server Error');
                  });
                } else if (response.status === 503) {
                //   throw new Error('Service temporarily unavailable. The server might be overloaded or under maintenance. Please try again in a few moments.');
                } else if (!response.ok) {
                //   throw new Error(`Server Error (${response.status}): ${response.statusText}`);
                }
                const contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                  return response.json();
                }
                return null; 
              })
              .then((data) => {
                setFormSubmit(false);
                setIsModalActive(false);
                setUploadBtnLoading(false);
              })
              .catch((error) => {
                setUploadBtnLoading(false);
                setFormSubmit(false);
                if (error.message.startsWith('Bad Request')) {
                //   uploadError("server");
                }
                else if (error.message.startsWith('Metafields')) {
                //   uploadError("metafield");
                }
              })
              .finally(() => {
                setIsModalActive(false);
              });
          }
        else {
          setFormSubmit(false);
          setIsUploadError(true);
          setErrModalActive(true);
          setUploadErrors({
            errorType: "validation",
            errors: ["Mapping the 'Handle' Shopify header is required."]
          });
        }
      };


    useEffect(() => {
        if (eventSource) {
            eventSource.onmessage = (event) => {
                const data = event.data;
                if (data.includes("processing")) {
                    setUploadBtnLoading(false);
                    setIsUploadError(false);
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setProcessingMsg("validating");
                    setEmailMarketingUpdate(undefined);
                    setFile(null);
                }
                if (data.includes("metaobjectValidation")) {
                    const { metaobjectValidation } = JSON.parse(data);

                    if (metaobjectValidation === true) {
                        setUploadBtnLoading(false);
                        setIsUploadError(false);
                        setBulkStatus("processing");
                        setProcessingMsg("calculating items");
                        setEmailMarketingUpdate(undefined);
                        setFile(null);
                    } else {
                        setFile(null);
                        setBulkStatus("failed");
                        setUploadStatus(false);
                        setPollingResult(undefined);
                        setUploadBtnLoading(false);
                        setIsUploadError(true);
                        setErrModalActive(true);
                        setUploadErrors(JSON.parse(data));

                    }
                } else if (data.includes("metaobjectuploading")) {
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setProcessingMsg("uploading");
                    setStagedUploadProgress(JSON.parse(data));
                    setUploadBtnLoading(false);

                } else if (data.includes("Metaobject delete")) {
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setProcessingMsg("Metaobject delete");
                    setMetaobjectDeleteStatus(JSON.parse(data));
                } else if (data.includes("MetaobjectMetafield delete")) {
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setProcessingMsg("Metafield delete");
                    setMetaDeleteStatus(JSON.parse(data));
                } else if (data.includes("bulkId")) {
                    const jsonObject = JSON.parse(data);
                    if (jsonObject) {
                        const { status } = jsonObject;

                        if (status.toLowerCase() === "completed") {
                            setPollingResult(jsonObject);
                            setBulkStatus(status);
                            setUploadStatus(false);
                            getLogs();
                        } else if (status.toLowerCase() === "canceled") {
                            setUploadStatus(false);
                            setBulkStatus(status);
                            getLogs();
                        } else {
                            setUploadStatus(true);
                            setBulkStatus(status);
                            setPollingResult(jsonObject);
                        }
                    }
                } else if (data.includes("MetaobjectCatalog extract")) {
                    const jsonObject = JSON.parse(data);
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setCatalogExtractMsg(jsonObject);
                    setProcessingMsg("Catalog extract");
                    setUploadBtnLoading(false);
                } else if (data.includes("Split metaobjects")) {
                    const jsonObject = JSON.parse(data);
                    setPollingResult(undefined);
                    setUploadStatus(true);
                    setBulkStatus("processing");
                    setProcessingMsg("Split metaobjects");
                    setUploadBtnLoading(false);
                    setSplitMetaobjects(jsonObject);
                } else if (data.includes("bulkop")) {
                    const jsonObject = JSON.parse(data);
                    if (jsonObject?.status?.toLowerCase() === "canceled") {
                        setUploadStatus(false);
                        setBulkStatus("canceled");
                        setPollingResult(undefined);
                        setBulkCancelStatus("");
                        getLogs();
                    } else {
                        setBulkCancelStatus(jsonObject.status);
                    }
                } else if (data === "pong") {
                } else if (data === "metaobjectDownloadComplete") {
                    setDownloadSpinner(false);
                    getConfigExport();
                }
                else if (data.includes("metaobjectfailed")) {
                    setExportStatus("failed");
                    setDownloadSpinner(false);
                }
                else if (data.includes("Export")) {
                    if (exportConfig === null && !isExportConfig) {
                        isExportConfig = true;

                    }
                    try {
                        const jsonObject = JSON.parse(data);
                        if (jsonObject) {
                            const { type, status, completedAt } = jsonObject;
                            if (type.includes("Product")) { setMutationType("product"); }
                            else if (type.includes("Metaobject")) { setMutationType("metaobject"); setExportResult(jsonObject); }
                            if (status.toLowerCase() === "completed" || status.toLowerCase() === "failed" || status.toLowerCase() === "expired") {
                                setDownloadSpinner(false);
                                setExportBtnLoading(false);
                                if (type.includes("Metaobject")) {
                                    setExportResult(jsonObject);
                                    setExportStatus(status.toLowerCase());
                                    setExportCompletedAt(completedAt);
                                }

                                if (type === "MetaobjectExport") {
                                    setDownloadSpinner(false);
                                    setExportBtnLoading(false);
                                }
                            }
                            setExportStatus(status.toLowerCase());
                        }
                    } catch (err) {
                        console.warn("Non-JSON message received:", data);
                    }
                }

            }

        }
        return () => {
            if (eventSource) {
                eventSource.onmessage = null; // Remove the event handler
            }
        };
    }, [eventSource]);

    const activator = (
        <s-button onClick={togglePopoverActive} disclosure>
            Export
        </s-button>
    );



    const bulkResponseErrorModal = (
        <s-modal size='large'
            open={bulkErrorActive}
            onClose={handleBulkErrorChangeModal}
        >
            <div slot="title">Failed metaobjects</div>
            {bulkErrors.map(
                ({ handle, userErrors }, index) => (
                    <s-box key={index} paddingBlockEnd="base" borderBlockEndWidth={index < bulkErrors.length - 1 ? "025" : "0"} borderColor="border">
                        <s-stack gap="extra-small">
                            <s-text>#{index + 1}&nbsp;Handle: {handle}</s-text>
                            {userErrors.map(
                                ({ message, fieldName, fieldValue }, index) => (
                                    <s-banner tone="critical" key={index}>
                                        <s-text>{message}</s-text>
                                        {fieldName ? <s-text>Field: {fieldName}</s-text> : null}
                                        {fieldValue ? <s-text>Value: {fieldValue}</s-text> : null}
                                    </s-banner>
                                ))}
                        </s-stack>
                    </s-box>
                ))}
        </s-modal>
    );


    // ========== Plan Authorization Functions ==========
    
    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    function generateMetaobjectErrorModal(errors) {
        console.log("error model meta called",errors);
        setBulkErrors(errors);
        setBulkErrorActive(true);

        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    function generateMetafieldErrorModal(errors) {
        setBulkMetaErrors(errors);
        setBulkMetaErrorActive(true);

        setTimeout(() => {
            const modal = document.getElementById('bulk-meta-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    const [exportCompletedAt, setExportCompletedAt] = useState('');
    // const [exportModalActive, setExportModalActive] = useState(false);
    // const exportModal = (
    //     <>
    //         <Modal
    //             primaryAction={{
    //                 content: 'Export',
    //                 onAction: exportAllMetaobjects,
    //                 disabled: exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false,
    //             }}
    //             open={exportModalActive}
    //             title="Export"
    //             onClose={() => {setExportModalActive(false)}}>
    //                 <Modal.Section>
    //                     <Banner
    //                         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //                         onDismiss={false}>
    //                         <Text>
    //                             {exportStatus === "completed" ?
    //                                 "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed on " + new Date(exportCompletedAt).toLocaleDateString() + " at " + new Date(exportCompletedAt).toLocaleTimeString() + ". "
    //                                 : exportStatus === "" ?  "No previous export Found. Please export again." :  "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus + (exportStatus !== "failed" ? ". This may take a few moments." : ".")}
    //                             {exportStatus === "completed" && !downloadSpinner? <Link url="" onClick={() => {
    //                                 setDownloadSpinner(true);
    //                                 window.location.href = endpoint + '/api/Metaobject/download-previous-export?storeUrl=' + storeUrl;
    //                             }}>Download</Link> : downloadSpinner ? <Spinner  size="small" /> : null}
    //                         </Text>
    //                     </Banner>
    //                 </Modal.Section>
                    
    //         </Modal>
    //     </>
    // );

    const modal = (
        <s-modal
            id="export-modal"
            heading="Export"
        >
            {exportModalLoading === false ?
                <s-box padding="none">
                    <s-select
                        label="Type"
                        help-text={
                            selectedType !== "" 
                                ? `${selectedType} has ${totalMetaobjectCount ?? 0} metaobjects.` 
                                : "Select a type to view the metaobject count."
                        }
                        value={selectedType}
                        onChange={(e) => { 
                            const value = e.currentTarget.value;
                            setSelectedType(value);
                            setTotalMetaobjectCount(metaobjectDefinitions.find(x => x.type === value).metaobjectsCount)
                        }}
                    >
                        {metaobjectDefinitions.map((option) => (
                            <s-option key={option.type} value={option.type}>{option.type}</s-option>
                        ))}
                    </s-select>
                    
                    {exportFilterMsg !== null && (
                        <s-text tone="success">{exportFilterMsg}</s-text>
                    )}
                </s-box>
                : 
                <s-box padding="large">
                    <s-stack alignment="center" inline-align="center">
                        <s-spinner size='small' />
                    </s-stack>
                </s-box>
            }

            <s-button 
                slot="secondary-actions"
                commandFor="export-modal"
                command="--hide"
            >
                Cancel
            </s-button>
            <s-button
                slot="primary-action"
                variant="primary"
                onClick={() => { exportMetaobjectsByType(); }}
                commandFor="export-modal"
                command="--hide"
                disabled={!["completed", "", "canceled", "expired","failed"].includes(exportStatus) || !!uploadStatus || !!blockUpload || exportModalLoading}
            >
                Export
            </s-button>
        </s-modal>
    );

    return (
        <s-page heading='Metaobjects'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                commandFor="export-modal"
                onClick={() => QueryMetaobjectDefinitions()}
                disabled={exportStatus !== "running" && !uploadStatus && !blockUpload ? false : true}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportBtnLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus}${exportStatus !== "failed" && exportStatus !== "canceled" ? ". This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>

            {/* Trial Expired Banner */}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />
            
            {/* Main Card - Two columns layout with grid */}
            <s-stack gap="base">
            <s-section padding="base">
                <s-box padding="none">
                    <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                        <s-grid-item gridColumn="span 6">
                            <s-stack gap="small">
                                {/* DropZone Section */}
                                <s-stack gap="small-100">
                                    <s-heading>Upload File</s-heading>
                                    <s-link onClick={() => openSampleFile()}>
                                        Download a sample file
                                    </s-link>
                                    
                                    <s-drop-zone
                                        key={dropZoneKey}
                                        multiple={false}
                                        accept=".csv,.xlsx"
                                        onInput={(event) => {
                                            const files = event.currentTarget.files;
                                            if (files && files.length > 0) {
                                                handleDropZoneDrop([], Array.from(files), []);
                                            }
                                            // Clear native value so selecting the same file path can trigger input again.
                                            if (event.currentTarget && "value" in event.currentTarget) {
                                                event.currentTarget.value = "";
                                            }
                                        }}
                                    >
                                        {uploadedFile}
                                        {fileUpload}
                                    </s-drop-zone>
                                    
                                    <s-text color="subdued">
                                        Accepts .csv/.xlsx format. Maximum size: 20 MB
                                    </s-text>
                                </s-stack>

                                {/* Action Buttons Section */}
                                <s-stack gap="small-100">
                                    <s-stack direction="inline" gap="small">
                                        <s-button
                                            variant="primary"
                                            disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                            loading={uploadBtnLoading}
                                            onClick={() => FileUploadValidation()}
                                        >
                                            Upload
                                        </s-button>
                                        {/* <s-button 
                                            variant="secondary" 
                                            onClick={() => openSampleFile()}
                                        >
                                            Download sample
                                        </s-button> */}
                                    </s-stack>
                                    
                                    {hasError && (
                                        <s-text as="p" tone="critical">
                                            {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                        </s-text>
                                    )}
                                </s-stack>
                            </s-stack>
                        </s-grid-item>
                        
                        <s-grid-item gridColumn="span 6">
                            {/* Note Section with Image Watermark */}
                            <div style={{ position: 'relative'}}>
                                {/* Watermark Image Background */}
                                <div 
                                    style={{
                                        position: 'absolute',
                                        bottom: '-65px',
                                        right: '10px',
                                        width: '300px',
                                        height: '300px',
                                        backgroundImage: `url(${WatermarkImage})`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'bottom right',
                                        opacity: '0.15',
                                        pointerEvents: 'none',
                                        zIndex: 0
                                    }}
                                />
                                
                                {/* Note Content - On top of watermark */}
                                <div style={{ position: 'relative', zIndex: 1 }}>
                                    <s-stack gap="small-100">
                                        <s-heading>Note</s-heading>
                                        <s-unordered-list>
                                            <s-list-item>
                                                Metafields are separate column headers with the format: <s-text type="strong">metaobject/namespace/metafield-name/type</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                To delete a metafield, end the header with <s-text type="strong">'/delete'</s-text>
                                            </s-list-item>
                                            <s-list-item>
                                                Image urls in metafields can be comma(,) separated in the first row of the metaobject.
                                            </s-list-item>
                                            <s-list-item>
                                                Image urls from Google Drive and Dropbox share links are automatically updated by us to be accepted in Shopify
                                            </s-list-item>
                                            <s-list-item>
                                                The app supports bulk operations for metaobjects and their metafields efficiently
                                            </s-list-item>
                                        </s-unordered-list>
                                    </s-stack>
                                </div>
                            </div>
                        </s-grid-item>
                    </s-grid>
                </s-box>
            </s-section>
            </s-stack>
            
            <ImportProcessing
                bulkStatus={bulkStatus}
                uploadStatus={uploadStatus}
                pollingResult={pollingResult}
                setErrModalActive={setErrModalActive}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                stagedUploadProgress={stagedUploadProgress}
                splitItems={splitMetaobjects}
                productDeleteStatus={metaobjectDeleteStatus}
                metaDeleteStatus={metaDeleteStatus}
                productBulkCancelStatus={metaobjectBulkCancelStatus}
                cancelBulk={cancelBulk}
                generateProductErrorModal={generateMetaobjectErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
                emailMarketingUpdate={emailMarketingUpdate}
            />
            
            {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running" ?
                
                    <ExportStatusCard exportResult={exportResult} progress={0} exportConfig={exportConfig} currentRoute="metaobject" />
                
                : null}
            
            {/* Import History Section */}
            <s-box paddingBlockStart="base">
            <s-section padding="none">
                {/* <s-box padding="base">
                    <s-grid gridTemplateColumns="1fr auto" gap="none">
                        <s-heading>History</s-heading>
                        <s-box padding-block-end="small-200">
                            <s-text tone="subdued">
                                Imports from last 7 days
                            </s-text>
                        </s-box>
                    </s-grid>
                </s-box> */}
                
                <ImportHistory
                    logs={logs}
                    generateProductErrorModal={generateMetaobjectErrorModal}
                    generateMetafieldErrorModal={generateMetafieldErrorModal}
                    downloadResult={downloadResult}
                    loadingMap={loadingMap}
                    logsLoading={logsLoading}
                />
                
                {logs.length !== 0 && (
                    <s-stack direction="inline" align="center">
                        <s-pagination
                            has-previous={prvButton}
                            onPrevious={() => prev()}
                            has-next={nxtButton}
                            onNext={() => next()}
                        />
                    </s-stack>
                )}
            </s-section>
            </s-box>
            
            {errorModal({ bulkErrorActive, handleBulkErrorChangeModal, bulkErrors, currentRoute: 'metaobject' })}
            {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })}
            {/* {exportModal} */}
            {modal}
            <MappingModal
                active={isModalActive}
                setActive={setIsModalActive}
                shopifyHeaders={shopifyHeaders}
                catalogHeaders={catalogHeaders}
                setTypeSelected = {setSelectedType}
                mapModalLodaing={mapModalLodaing}
                setMappedHeaders={setMappedHeaders}
                setFormSubmit={setFormSubmit}
                currentRoute={"metaobject"}
                blockUpload = {blockUpload}
            />
            {bulkErrors.length > 0 ? bulkResponseErrorModal : null}
            {isUploadError ? <ValidationErrorModal
                errModalActive={errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            /> : null}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />

            {/* {resultDownloadErrorToast} */}

        </s-page>
        // </Frame>
    );

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadMetaobjectBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function openSampleFile() {
        window.open(environment.sampleMetaobjectFile, '_blank');
      }

    async function cancelBulk(bulkId) {
        metaobjectBulkCancel(storeUrl, bulkId).then(function (result) {
            setBulkCancelStatus("canceling");
            getLogs();
        });
    }

    async function uploadChunk(chunk, chunkIndex, totalChunks) {
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);

        const response = await fetch(endpoint + '/api/Metaobject/file-validation-chunk', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            throw new Error('Chunk upload failed');
        }
    }

    async function FileUploadValidation() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            return;
        }
        
        setFormSubmit(false);
        if (file !== null) {
            QueryMetaobjectDefinitions(); 
            setBulkCancelStatus("");
            setIsUploadError(false);
            setUploadErrors(false);
            setBulkErrors([]);
            setUploadBtnLoading(true);

            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            let allChunksUploaded = true;

            try {
                for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                    const start = chunkIndex * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, file.size);
                    const chunk = file.slice(start, end);

                    try {
                        await uploadChunk(chunk, chunkIndex, totalChunks);
                    } catch (error) {
                        allChunksUploaded = false;
                        setUploadBtnLoading(false);
                        setIsUploadError(true);
                        setUploadErrors({
                            errorType: "exception",
                            errors: ["File upload failed. Please try again."]
                        });
                        setErrModalActive(true);
                        break;
                    }
                }

                if (allChunksUploaded) {
                    const formData = new FormData();
                    formData.append('fileName', file.name);
                    formData.append('totalChunks', totalChunks);
                    formData.append('storeUrl', storeUrl);
                    formData.append('type', selectedType);

                    fetch(endpoint + '/api/Metaobject/read-catalog-headers', {
                        method: 'POST',
                        body: formData,
                    })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(data => {
                            // const defaultCSVHeaders = ["null"];
                            const fileHeaders = [data?.fileHeaders];
                            setCatalogHeaders(...fileHeaders);
                            const headersShopify = [data?.shopifyHeaders];
                            setShopifyHeaders(...headersShopify);
                            setUploadBtnLoading(false);
                            setIsModalActive(true);
                        })
                        .catch(error => {
                            setUploadBtnLoading(false);
                            setIsUploadError(true);
                            setUploadErrors({
                                errorType: "exception",
                                errors: ["Failed to process file headers. Please check your file format."]
                            });
                            setErrModalActive(true);
                        });
                }
            } catch (error) {
                setUploadBtnLoading(false);
                setIsUploadError(true);
                setUploadErrors({
                    errorType: "exception",
                    errors: ["An error occurred while uploading the file. Please try again."]
                });
                setErrModalActive(true);
            }
        }
    }


    function deleteOlderLogs() {
        DeleteMetaobjectLogs(storeUrl).then(function (result) {
        });
    }


    function statusPolling() {
        MetaobjectBulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                if (status.toLowerCase() === "completed") {
                    setPollingResult(result);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    function checkExportStatus() {
        metaobjectExportStatus(storeUrl).then(function (result) {
            setDownloadSpinner(true);
            if (result !== null) {
                var status = result?.status?.toLowerCase();
                var type = result.type
                if (status === "completed" && type === "metaobject") {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportCompletedAt(result.completedAt)
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
                else if (type === "metaobject" && status === "running" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (type === "metaobject" && status === "processing" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (status === "failed" && type === "metaobject") {
                    setDownloadSpinner(false);
                    setMutationType(type);
                    setExportResult(result);
                    setExportStatus("failed")
                    
                }

                else if (status === "failed" && type === "product") {
                    setExportStatus("completed")
                    setDownloadSpinner(false);
                }

                else if (type !== "metaobject" && status === "running" )
                {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                }

                else {
                    // setMutationType(type);
                    // setExportStatus("")
                    // checkPrevExport();
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
            }
            else
            {
                setDownloadSpinner(false);
            }
        })
    }
    function ValidatePrice(price) {
        if (validConversionPrice.test(price)) {
            return true;
        }
        else {
            return false;
        }

    }

    function getLogs() {
        setLogsLoading(true);
        getMetaobjectImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount((result.totalCount / pageSize) + 1);
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }



    function getConfigExport() {
        getExportConfig(storeUrl,"metaobject").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
                if (result.status === "completed") {
                    setExportBtnLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                    
                }
                else if (result.status  === "failed") {
                    setExportBtnLoading(false);
                    setDownloadSpinner(false);
                    setExportStatus(result.status);
                }
                else if (result.status === "running") {
                    setExportBtnLoading(true);
                    setExportStatus(result.status);
                }
                else {
                    setExportBtnLoading(true);
                    setExportStatus(result.status);
                }
            }
        });
    }

    function QueryMetaobjectDefinitions() {
        setExportModalLoading(true);
        MetaobjectDefinitions(storeUrl).then(function (result) {
            if (result !== null) {
                setSelectedType(result[0]?.type);
                setTotalMetaobjectCount(result[0]?.metaobjectsCount);
                setMetaobjectDefinitions(result);
                setExportModalLoading(false);
            }
            else
            {
                setExportModalLoading(false);
            }
        });
    }

    function GetMetaObjectFields() {
        setMapModalLoading(true);
        try {
            MetaobjectFields(storeUrl, selectedType).then(function (result) {
                if (result !== null) {
                    setShopifyHeaders(result);

                }
                setMapModalLoading(false);
            }).catch(function (error) {
                console.error('Error fetching metaobject fields:', error);
                setMapModalLoading(false);
            });
        } catch (error) {
            console.error('Error in GetMetaObjectFields:', error);
            setMapModalLoading(false);
        }
    }

    async function exportMetaobjectsByType() {
        // Check trial authorization
        if (!checkTrialAccess()) {
            handleChangeModal(); // Close the export modal
            return;
        }
        
        // Set initial export state
        setExportStatus('running');
        setExportBtnLoading(true);
        
        // Initialize export result with running status
        setExportResult({
            type: 'MetaobjectExport',
            status: 'RUNNING',
            createdAt: new Date().toISOString(),
            completedAt: null,
            rootObjectCount: 0
        });
        
        // Initialize export config with running status if it's null
        if (exportConfig === null) {
            setExportConfig({
                status: 'running',
                createdAt: new Date().toISOString(),
                fileUrl: null
            });
        }
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        const url = new URL(endpoint + '/api/Metaobject/metaobjects-export');
        url.searchParams.append('storeUrl', storeUrl);
        url.searchParams.append('type', selectedType);
        fetch(url, requestOptions)
            .then(response => {
                if (response.status === 200 && response !== null) {
                    setExportBtnLoading(false);
                }
                else if (response.status === 400) {
                    setExportBtnLoading(false);
                    return response.statusText
                }
            })
            .catch(error => {
                setExportBtnLoading(false);
                return []
            })
    }

    
    
}

